import React from "react";
import Export from "./Export";
import { exportToExcel } from "../hooks/exportToExcel";
import printChart from "../../../../../PrintChart";

const Header = ({ filteredData, storess, chartContainerId }) => (
  <div className="d-flex justify-content-between align-items-center">
    <h2 className="fw-bold text-capitalize">
      <span>Share of </span>
      <span style={{ color: "#83c14a" }}>Sales Contribution</span>
    </h2>
    <Export
      exportCsv={() => exportToExcel(filteredData, storess)}
      exportPdf={() => printChart(chartContainerId)}
    />
  </div>
);

export default Header;
